module.exports = __webpack_public_path__ + "static/media/clear.f292a19f.svg";